import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast, types } from "@vilocnv/allsetra-core";
import i18n from "i18next";
import { getDriverMileageByQuery } from "../../api/get-driver-mileage";

export const getDriverMileageByQueryThunk = createAsyncThunk(
  "driverMileage/getDriverMileageByQueryThunk",
  async (
    args:
      | {
          accountId: string;
          params: types.IRecordsAggregationBody;
        }
      | types.IRecordsAggregationBody
  ) => {
    // Handle case where args is just params (when accountId is missing)
    if (!("accountId" in args)) {
      return { results: [], rowCount: 0 };
    }

    const { accountId, params } = args;

    if (!accountId) {
      return { results: [], rowCount: 0 };
    }

    try {
      const response = await getDriverMileageByQuery(accountId, params);
      return response;
    } catch (e: any) {
      console.error(e);
      toast.error(i18n.t("toasts.getDriverMileageError"));
      throw new Error(e);
    }
  }
);
